<template>
  <div class="setFloatingPage">
    <div class="checkbox">
      <input type="checkbox" id="page_is_floating" v-model="isFloatingPage">
      <label for="page_is_floating">플로팅 형태로 열기</label>
    </div>

    <div v-if="isFloatingPage" class="mt15">
      <div class="spot9 mb15">
        <div class="setLabel">{{ locale.position }}</div>
        <div class="box">
          <div
            v-for="pos in FLOATING_POS"
            :key="pos"
            :class="{radioItem: true, active: floatingPagePos === pos}">
            <input type="radio" name="background_pos" :id="`floating_page_pos_${pos}`" :value="pos" v-model="floatingPagePos">
            <label :for="`floating_page_pos_${pos}`"></label>
          </div>
        </div>
      </div>
      <div class="mb15">
        <div class="setLabel">{{ locale.size }} <span class="stkr stkrGrey">Mobile</span></div>
        <div class="flexContainer">
          <div class="flexItem">
            <label class="colorGrey mr5">{{ locale.width }}</label>
            <div class="unitInput mr15">
              <input type="text" class="input" v-model="floatingPageSize.mobileW">
            </div>
          </div>
          <div class="flexItem">
            <label class="colorGrey mr5">{{ locale.height }}</label>
            <div class="unitInput">
              <input type="text" class="input" v-model="floatingPageSize.mobileH">
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="setLabel">{{ locale.size }} <span class="stkr stkrGrey">Tablet</span></div>
        <div class="flexContainer">
          <div class="flexItem">
            <label class="colorGrey mr5">{{ locale.width }}</label>
            <div class="unitInput mr15">
              <input type="text" class="input" v-model="floatingPageSize.tabletW">
            </div>
          </div>
          <div class="flexItem">
            <label class="colorGrey mr5">{{ locale.height }}</label>
            <div class="unitInput">
              <input type="text" class="input" v-model="floatingPageSize.tabletH">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'

const DEFAULT_SIZE = () => ({
  mobileW: '100%',
  mobileH: '100%',
  tabletW: '100%',
  tabletH: '100%',
})

function clone(obj) {
  // floatingPageData 구조가 단순(문자/불리언/평범한 객체)이면 이걸로 충분
  return obj ? JSON.parse(JSON.stringify(obj)) : obj
}

export default {
  name: 'SetFloatingPage',
  props: {
    locale: { type: Object, required: true },
    link: { type: Object, default: null },
    floatingPageData: { type: Object, default: null },
  },

  data() {
    return {
      FLOATING_POS: [
        'tl', 'tc', 'tr',
        'cl', 'cc', 'cr',
        'bl', 'bc', 'br'
      ],
      isFloatingPage: false,
      floatingPagePos: 'br',
      floatingPageSize: DEFAULT_SIZE(),
      _syncingFromProp: false,
      _emitTimer: null
    }
  },

  watch: {
    floatingPageData: {
      immediate: true,
      deep: true,
      handler(fp) {
        this._syncingFromProp = true
        try {
          if (!fp) return

          if (typeof fp.isFloatingPage === 'boolean') this.isFloatingPage = fp.isFloatingPage
          if (typeof fp.floatingPagePos === 'string') this.floatingPagePos = fp.floatingPagePos

          const size = fp.floatingPageSize && typeof fp.floatingPageSize === 'object'
            ? fp.floatingPageSize
            : null

          // 복사로 참조 공유 끊기
          this.floatingPageSize = Object.assign(DEFAULT_SIZE(), clone(size) || {})
        } finally {
          // 다음 tick에서 syncing 해제(연쇄 watch 안정화)
          this.$nextTick(() => { this._syncingFromProp = false })
        }
      }
    },

    isFloatingPage() { this._scheduleEmit() },
    floatingPagePos() { this._scheduleEmit() },
    floatingPageSize: {
      deep: true,
      handler() { this._scheduleEmit() }
    }
  },

  beforeDestroy() {
    if (this._emitTimer) clearTimeout(this._emitTimer)
  },

  methods: {
    _scheduleEmit() {
      if (this._syncingFromProp) return

      // input 타이핑마다 store commit 때리는 것 방지
      if (this._emitTimer) clearTimeout(this._emitTimer)
      this._emitTimer = setTimeout(() => {
        this.update()
      }, 150)
    },

    update() {
      if (this._syncingFromProp) return

      this.$emit('update', {
        id: this.link?.id || UNIQUE.mid(),
        floatingPageData: {
          isFloatingPage: this.isFloatingPage,
          floatingPagePos: this.floatingPagePos,
          floatingPageSize: clone(this.floatingPageSize),
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.setFloatingPage {
  padding: 16px;
  border-radius: 8px;
  background-color: $bg-default;
}
.spot9 {
  max-width: 90px;
  .box {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 2px;
  }
  .radioItem {
    label {
      display: block;
      height: 30px;
    }
    border-radius: 4px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    &.active {
      border-color: $color-dark;
      background-color: $color-dark;
    }
  }
}
.stkr {
  display: inline-block;
  margin-left: 10px;
  padding: 2px 5px;
  font-size: 11px;
  font-weight: normal;
  color: $color-grey;
  border-radius: 4px;
  border: 1px solid $color-lgrey2;
  background-color: $color-white;
}
</style>
